import React, { useState } from 'react';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

export default function UserGuideSection(props) {
    const [showContent, setShowContent] = useState(false);
    const toggle = () => {
        setShowContent(!showContent);
    };

    return (
        <div className={`my-3 ${!props.isCategory ? 'ml-3' : ''}`}>
            <div className={'card bg-white border-0 rounded-15px py-0 shadow'}>
                <div
                    className="card-header d-flex justify-content-between px-4"
                    style={{
                        borderTopLeftRadius: '15px',
                        borderTopRightRadius: '15px',
                        borderBottomLeftRadius: showContent ? '0' : '15px',
                        borderBottomRightRadiusRadius: showContent ? '0' : '15px',
                    }}
                >
                    <div className="d-flex">
                        <h4 className="text-center text-blue tw-cursor-pointer" onClick={toggle}>
                            {props.item.section}
                        </h4>
                        {props.isCategory && (
                            <div className="tw-pl-2 tw-flex tw-items-center tw-cursor-pointer" onClick={props.toggleExpanded}>
                                {props.expanded && <ChevronUpIcon className="tw-h-3 tw-w-3 tw-mx-auto tw-my-auto" />}
                                {!props.expanded && <ChevronDownIcon className="tw-h-3 tw-w-3 tw-mx-auto tw-my-auto" />}
                            </div>
                        )}
                    </div>
                    <div onClick={toggle}>
                        {showContent ? <ChevronUpIcon className="tw-w-2.5 tw-h-2.5" /> : <ChevronDownIcon className="tw-w-2.5 tw-h-2.5" />}
                    </div>
                </div>
                <div className={`card bg-white border-0 rounded-15px py-2 shadow ${showContent ? '' : 'hidden'}`}>
                    <div className="px-4" dangerouslySetInnerHTML={{ __html: props.item.content }} />
                </div>
            </div>
        </div>
    );
}
